import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import * as dayjs from "dayjs";
import { CampanaService } from "../campana.service";

@Component({
  selector: "app-form-campana",
  templateUrl: "./form.component.html",
})
export class CampanaForm implements OnInit {
  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";

  public phase: "campain" | "days" | "resume" = "campain";
  @Output() onsave = new EventEmitter<{
    mode: string;
    value: any;
    poliza: File;
  }>();

  public unidadesActivas = [];
  public unidadesLibres = [];
  public groups = [];
  public currentDate = null;
  public currentSelectionToAdd = [];
  public currentSelectionToAddStr = [];
  colorSelected: string = "whitesmoke";
  isDarkBG: boolean = false;
  today: Date = null;
  constructor(
    private fb: FormBuilder,
    private serv: CampanaService,
  ) {}

  public ngOnInit() {
    this.buildForm();
    this.today = dayjs().toDate();
    this.serv.getUnits().subscribe((next) => {
      this.unidadesActivas = next;
      this.unidadesLibres = next;
    });
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      Titulo: new FormControl("", [Validators.required]),
      Descripcion: new FormControl("", [Validators.required]),
      Color: new FormControl("", [Validators.required]),
    });
  }

  nextPhase() {
    if (this.phase == "campain") {
      this.phase = "days";
      this.colorSelected = this.form.value.Color;
      this.isDarkBG = colorIsDarkSimple(this.colorSelected);
    } else if (this.phase == "days") {
      this.phase = "resume";
    } else if (this.phase == "resume") {
      this.save();
    }
    this.currentDate = null;
  }

  returnPhase() {
    if (this.phase == "days") {
      this.phase = "campain";
    } else if (this.phase == "resume") {
      this.phase = "days";
    }
    this.currentDate = null;
  }

  addUnit(unit) {
    if (!this.currentSelectionToAddStr.includes(unit.NoControl)) {
      this.currentSelectionToAdd.push(unit);
      this.currentSelectionToAddStr.push(unit.NoControl);
    } else {
      const temp = this.currentSelectionToAdd.filter(
        (f) => f.NoControl != unit.NoControl,
      );
      this.currentSelectionToAdd = temp;
      this.currentSelectionToAddStr = temp.map((t) => t.NoControl);
    }
  }

  isActiveDay(nocontrol) {
    if (this.currentSelectionToAddStr.includes(nocontrol)) {
      return {
        color: this.isDarkBG ? "#FFF" : "#000",
        "background-color": this.colorSelected,
      };
    }

    return { color: "#000", "background-color": "transparent" };
  }

  badgeStyle() {
    return {
      color: this.isDarkBG ? "#FFF" : "#000",
      "background-color": this.colorSelected,
    };
  }

  addUnits() {
    const inx = this.groups.findIndex((f) => f.day == this.currentDate);
    if (inx != -1) {
      const temp = this.groups[inx].units;
      const newUnits = [...temp, ...this.currentSelectionToAdd];

      this.groups[inx].units = newUnits;
      this.groups[inx].unitsStr = newUnits
        .flatMap((f) => f.NoControl)
        .join(",");
    } else {
      const temp = {
        day: this.currentDate,
        units: this.currentSelectionToAdd,
        unitsStr: this.currentSelectionToAdd
          .flatMap((f) => f.NoControl)
          .join(","),
      };
      this.groups = [...this.groups, temp];
    }

    this.currentDate = null;
    this.currentSelectionToAdd = [];
    this.currentSelectionToAddStr = [];
    const unidadesUsadas = this.groups
      .flatMap((t) => t.units)
      .flatMap((f) => f.IdUnidad);

    this.unidadesLibres = this.unidadesActivas.filter(
      (f) => !unidadesUsadas.includes(f.IdUnidad),
    );
  }

  drawerRef: any;
  save() {
    const temp = this.form.value;
    const data = { ...temp, groups: this.groups };
    this.drawerRef.close({
      data: data,
    });
  }
}
function colorIsDarkSimple(bgColor) {
  const color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
  const r = parseInt(color.substring(0, 2), 16); // hexToR
  const g = parseInt(color.substring(2, 4), 16); // hexToG
  const b = parseInt(color.substring(4, 6), 16); // hexToB
  return r * 0.299 + g * 0.587 + b * 0.114 <= 186;
}
